import { render, staticRenderFns } from "./VueColorWrapper.vue?vue&type=template&id=48b43aa2&"
import script from "./VueColorWrapper.vue?vue&type=script&lang=ts&"
export * from "./VueColorWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports